import { configureStore } from '@reduxjs/toolkit';
import globalExperienceReducer from './slices/GlobalExperience';
import gameExperienceReducer from './slices/GameExperience';
import displayScreenReducer from './slices/DisplayedScreen';
import retailerPersonalDataReducer from './slices/GlobalRetailerPersonalData';
import smartOptinsReducer from './slices/SmartOptins';

export const store = configureStore({
  reducer: {
    displayScreen: displayScreenReducer,
    gameExperience: gameExperienceReducer,
    globalExperience: globalExperienceReducer,
    retailerPersonalData: retailerPersonalDataReducer,
    smartOptins: smartOptinsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
